'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('ngreact');

var _placementTable = require('./placement-table.js');

var _placementTable2 = _interopRequireDefault(_placementTable);

var _scoresheetTable = require('./scoresheet-table.js');

var _scoresheetTable2 = _interopRequireDefault(_scoresheetTable);

var _ifeisIsomorphic = require('ifeis-isomorphic');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _getScoresheets = require('ifeis-isomorphic/lib/redux/actions/scores/getScoresheets');

var _getScoresheets2 = _interopRequireDefault(_getScoresheets);

var _getEventPlacements = require('ifeis-isomorphic/lib/redux/actions/events/getEventPlacements');

var _getEventPlacements2 = _interopRequireDefault(_getEventPlacements);

var _getParticipants = require('ifeis-isomorphic/lib/redux/actions/events/getParticipants');

var _getParticipants2 = _interopRequireDefault(_getParticipants);

var _getCommentsForPerson = require('ifeis-isomorphic/lib/redux/actions/comments/getCommentsForPerson');

var _getCommentsForPerson2 = _interopRequireDefault(_getCommentsForPerson);

var _getDressCheckForPerson = require('ifeis-isomorphic/lib/redux/actions/dress-checks/getDressCheckForPerson');

var _getDressCheckForPerson2 = _interopRequireDefault(_getDressCheckForPerson);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _styles = require('./components/competitor-result/styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventResultDirective = function () {
  function EventResultDirective() {
    _classCallCheck(this, EventResultDirective);
  }

  _createClass(EventResultDirective, [{
    key: 'getPlacement',
    value: function getPlacement(event) {
      var lastNum = ('' + event.rank).substr(-1, 1);
      var suffix = 'th';

      switch (lastNum) {
        case '1':
          suffix = 'st';
          break;
        case '2':
          suffix = 'nd';
          break;
        case '3':
          suffix = 'rd';
          break;
      }

      return '' + event.rank + suffix + ' Place';
    }
  }, {
    key: 'getTotal',
    value: function getTotal(scores) {
      return scores.reduce(function (x, o) {
        return x + o;
      });
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      return (0, _ifeisIsomorphic.getDescription)(event.toJS());
    }
  }]);

  return EventResultDirective;
}();

var ResultsListDirective = function () {
  function ResultsListDirective($q, $ngRedux, $scope) {
    _classCallCheck(this, ResultsListDirective);

    this.loading = false;
    this._ = { $q: $q, $ngRedux: $ngRedux, $scope: $scope };

    /**
     * Cache for results so we only have to fetch them once, regardless how many times they are
     * expanded and collapsed.
     */
    this.details = {};
  }

  _createClass(ResultsListDirective, [{
    key: 'toggleRow',
    value: function toggleRow(result) {
      var _this = this;

      if (this.selected && this.selected.event === result.event) {
        delete this.selected;
        delete this.selectedIdx;
        return;
      }

      this.selected = result;
      this.selectedIdx = this.results.findIndex(function (r) {
        return r.event.get('id') === result.event.get('id');
      });

      if (this.getDetails(result)) {
        return;
      }

      // fetch data
      this.loading = true;

      var eid = result.event.get('id');
      var deets = { event: result.event };

      this._.$ngRedux.dispatch((0, _getEventPlacements2.default)(this.feis().id, result.event.get('id')));

      this._.$ngRedux.dispatch((0, _getParticipants2.default)(this.feis().id, result.event.get('id'))).then(function () {
        _this._.$ngRedux.dispatch((0, _getScoresheets2.default)(_this.feis().id, result.event.get('id')));
        if (result.event.get('commentsReleased') === 1) {
          _this._.$ngRedux.dispatch((0, _getCommentsForPerson2.default)(_this.feis().id, result.event.get('id'), _this.person.get('id')));
          _this._.$ngRedux.dispatch((0, _getDressCheckForPerson2.default)(_this.feis().id, result.event.get('id'), _this.person.get('id')));
        }
      });

      var mapResultList = (0, _mapStateToController2.default)(this.feis().id, this.person.get('id'), result.event.get('id'));

      this._.$ngRedux.connect(function (state) {
        _this.resultList = mapResultList(state);

        _this.selected = result;
        _this.selectedIdx = _this.results.findIndex(function (r) {
          return r.event.get('id') === result.event.get('id');
        });

        if (_this.resultList.loading) {
          return _extends({}, _this.resultList);
        }

        deets.placements = _this.resultList.placements.sort(function (a, b) {
          return a.get('score').get('placement') - b.get('score').get('placement');
        }).toJS();
        deets.adjudicators = _this.resultList.adjudicators;
        deets.scoresByAdjudicator = _this.resultList.scores && _this.resultList.scores.reduce(function (o, s, i) {
          o[deets.adjudicators.getIn([i, 'id'])] = s;
          return o;
        }, {});
        deets.scoresheets = _this.resultList.scores;

        _this._calculateDetails(result.event, deets);

        _this.details[eid] = deets;

        return { loading: false, details: _this.details };
      })(this);
    }
  }, {
    key: '_calculateDetails',
    value: function _calculateDetails(event, deets) {
      var _this2 = this;

      deets.comments = this.resultList.comments.reduce(function (accum, comment) {
        var matchingAdjudicatorRecord = accum.find(function (a) {
          return a.aid === comment.adjudicator;
        });
        if (!matchingAdjudicatorRecord) {
          accum.push({
            adjudicator: _this2.getAdjudicatorName(event.get('id'), comment.adjudicator, deets),
            aid: comment.adjudicator,
            comment: (comment.comments || {}).text || '',
            image: (comment.comments || {}).image
          });
          if (comment.comments.image && !deets.isImagePresent) {
            deets.isImagePresent = true;
          }
          return accum;
        } else {
          matchingAdjudicatorRecord.comment = _typeof(comment.comments) === 'object' && (comment.comments || {}).text || comment.comments;
          matchingAdjudicatorRecord.image = _typeof(comment.comments) === 'object' && (comment.comments || {}).image || undefined;
          var redefinedAccum = accum.filter(function (a) {
            return a.aid !== comment.adjudicator;
          });
          redefinedAccum.push(matchingAdjudicatorRecord);
          if (matchingAdjudicatorRecord.image && !deets.isImagePresent) {
            deets.isImagePresent = true;
          }
          return redefinedAccum;
        };
      }, []);

      deets.dressChecks = this.resultList.dressChecks.reduce(function (accum, dressCheck) {
        accum.push({
          adjudicator: _this2.getAdjudicatorName(event.get('id'), dressCheck.adjudicator, deets),
          aid: dressCheck.adjudicator,
          dressCheck: dressCheck.dressCheck.dressCheck
        });
        return accum;
      }, []);

      // Calculate scores for each scoresheet
      var calculator = new _ifeisIsomorphic.ScoreCalculator(event.toJS(), deets.placements);
      deets.scoresheets.forEach(function (scoresheet) {
        return calculator.addScoresheet(scoresheet);
      });
      deets.results = calculator.calculate();

      // Placements are set during score calculation (ugliness of pass-by-reference), so we re-order
      // all adjudicator scoresheets by participants' placement.
      Object.getOwnPropertyNames(deets.scoresByAdjudicator).forEach(function (aid) {
        return deets.scoresByAdjudicator[aid] = deets.scoresByAdjudicator[aid].sort(function (a, b) {
          return a.placement - b.placement;
        });
      });

      return deets;
    }
  }, {
    key: 'getAdjudicatorName',
    value: function getAdjudicatorName(eid, aid, deets) {
      var adj = deets.adjudicators.find(function (a) {
        return a.get('id') === aid;
      });

      return adj.get('fname') + ' ' + adj.get('lname');
    }
  }, {
    key: 'setDetails',
    value: function setDetails(result, details) {
      this.details[result.event.get('id')] = details;
    }
  }, {
    key: 'getDetails',
    value: function getDetails(result) {
      return this.details[result.event.get('id')];
    }
  }, {
    key: 'getEventName',
    value: function getEventName(event) {
      return (0, _ifeisIsomorphic.getDescription)(event);
    }
  }]);

  return ResultsListDirective;
}();

exports.default = angular.module('ifeis.results-list', ['ngMaterial', 'ifeis.events', 'react']).directive('fCompetitorResultsList', function () {
  return {
    bindToController: true,
    controller: ResultsListDirective,
    controllerAs: 'list',
    replace: true,
    scope: {
      feis: '&',
      person: '=',
      results: '='
    },
    template: require('./tpl.html')
  };
}).directive('fCompetitorResult', function () {
  return {
    bindToController: true,
    controller: EventResultDirective,
    controllerAs: 'event',
    scope: {
      result: '=',
      person: '=',
      details: '=',
      toggleRow: '&',
      expanded: '&',
      loading: '&'
    },
    template: require('./components/competitor-result/tpl.html')
  };
}).directive('placementTable', function (reactDirective) {
  return reactDirective(_placementTable2.default);
}).directive('scoresheetTable', function (reactDirective) {
  return reactDirective(_scoresheetTable2.default);
});


//////////////////
// WEBPACK FOOTER
// ./result-list/index.js
// module id = 506
// module chunks = 0